import {
  useInView as useBaseInView,
  type UseInViewOptions,
} from "framer-motion";
import { useEffect, useRef } from "react";
type TOptions = {
  triggerOnce?: boolean;
  onChange?: (inView: boolean) => any;
  rootMargin?: UseInViewOptions["margin"];
};
export function useInView<TRef extends Element = Element>(
  options: TOptions = {},
) {
  const ref = useRef<TRef>(null);
  const cbRef = useRef(options.onChange);
  cbRef.current = options.onChange;
  const inView = useBaseInView(ref, {
    once: options.triggerOnce,
    margin: options.rootMargin,
  });
  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(inView);
    }
  }, [inView]);
  return {
    ref,
    inView,
  };
}
